import { isAxiosError } from 'axios'

import { GetAgentIndicationDataByIndicationIdResponse } from '@/models/agent'

import api from './api'

interface GetAgentIndicationDataByIndicationIdProps {
  indicationId: string
  includeReason?: boolean
}

interface GetAgentIndicationDataByIndicationId {
  error: boolean
  data: GetAgentIndicationDataByIndicationIdResponse | null
  message: string | null
}

export async function getAgentIndicationDataByIndicationId({
  indicationId,
  includeReason = false,
}: GetAgentIndicationDataByIndicationIdProps): Promise<GetAgentIndicationDataByIndicationId> {
  try {
    const { data } =
      await api.get<GetAgentIndicationDataByIndicationIdResponse>(
        `/agent/indication/data/${indicationId}?includeReason=${includeReason}`,
      )

    return { error: false, data, message: null }
  } catch (err) {
    if (isAxiosError(err) && err.response) {
      const messageError = err.response?.data?.message

      return { error: true, data: null, message: messageError }
    }

    return {
      error: true,
      data: null,
      message:
        err instanceof Error
          ? err.message
          : 'Ocorreu um erro. Tente novamente mais tarde!',
    }
  }
}
